module.exports = __webpack_public_path__ + "img/N.f8ea6c16.svg";